import { useTranslation } from 'next-i18next';
import { SpaceWithPlanDto } from '../../../../types/SubscriptionType';
import { PlanCardsList } from './organisms';
export const SubscribedSpaces = ({
  spaceList
}: {
  spaceList: SpaceWithPlanDto[];
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div data-sentry-component="SubscribedSpaces" data-sentry-source-file="SubscribedSpaces.tsx">
      <label className="color-gray-900 mb-[10px] text-subtitle font-semibold">
        {t('subscription:SpaceList.heading.planApplied')}
      </label>
      <hr className="m-0 h-px border-t-gray-300" />
      <PlanCardsList spaceList={spaceList} data-sentry-element="PlanCardsList" data-sentry-source-file="SubscribedSpaces.tsx" />
    </div>;
};